export default "__VITE_ASSET__5cace7f9__"